module.exports = __webpack_public_path__ + "4effabd6fd1f692010334a3615f94cd7.pdf";